import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation, Link } from 'react-router-dom';
import { Building2, Calculator, Receipt, Stethoscope } from 'lucide-react';
export const Sidebar = () => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const location = useLocation();
  const ipseSaPaths = ['/', '/products', '/about', '/contact'];
  const isIpseSaPath = ipseSaPaths.includes(location.pathname);
  useEffect(() => {
    const footer = document.getElementById('main-footer');
    if (!footer) return;
    const observer = new IntersectionObserver(entries => {
      const [entry] = entries;
      setIsFooterVisible(entry.isIntersecting);
    }, {
      threshold: 0.1
    });
    observer.observe(footer);
    return () => {
      observer.unobserve(footer);
    };
  }, []);
  const menuItems = [{
    icon: <img src="/ipse-logo-white.png" alt="IPSE SA" className="w-7 h-7" />,
    label: 'IPSE SA',
    path: '/',
    color: 'text-blue-600',
    bgColor: 'from-blue-600 to-blue-700'
  }, {
    icon: <img src="/quickcont-logo-white.png" alt="QuickCont" className="w-7 h-7" />,
    label: 'QuickCont',
    path: '/quickcont',
    color: 'text-teal-600',
    bgColor: 'from-teal-600 to-teal-700'
  }, {
    icon: <img src="/facelec-logo-white.png" alt="Facelec+" className="w-7 h-7" />,
    label: 'Facelec+',
    path: '/facelec',
    color: 'text-orange-600',
    bgColor: 'from-orange-600 to-orange-700'
  }, {
    icon: <Stethoscope size={24} />,
    label: 'Galenos Web',
    path: '/galenos',
    color: 'text-red-600',
    bgColor: 'from-red-600 to-red-700'
  }];
  return <AnimatePresence>
      {!isFooterVisible && <motion.div className="fixed bottom-8 inset-x-0 flex justify-center z-50 w-auto mx-auto px-4 sm:px-6 lg:px-8" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.5
    }}>
          <div className="flex items-center justify-center gap-2 bg-gray-900/90 backdrop-blur-lg p-3 rounded-2xl shadow-2xl border border-white/10">
            {menuItems.map(item => {
          const isActive = item.path === '/' ? isIpseSaPath : location.pathname === item.path;
          const isHovered = hoveredItem === item.path;
          return <Link key={item.path} to={item.path} className="relative group" onMouseEnter={() => setHoveredItem(item.path)} onMouseLeave={() => setHoveredItem(null)}>
                  <motion.div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap shadow-lg" initial={{
              opacity: 0,
              y: 10,
              scale: 0.8
            }} animate={{
              opacity: isHovered ? 1 : 0,
              y: isHovered ? 0 : 10,
              scale: isHovered ? 1 : 0.8
            }} transition={{
              duration: 0.2
            }}>
                    {item.label}
                  </motion.div>
                  <motion.div className={`relative p-3 rounded-xl transition-all duration-300 ${isActive ? `bg-gradient-to-r ${item.bgColor} shadow-lg` : 'hover:bg-white/20'}`} whileHover={{
              scale: 1.2
            }} whileTap={{
              scale: 0.95
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 15
            }}>
                    <div className={`transition-colors duration-300 ${isActive ? 'text-white' : 'text-white group-hover:text-white'}`}>
                      {item.icon}
                    </div>
                    {isActive && <motion.div className="absolute -bottom-1 left-1/2 w-1 h-1 bg-white rounded-full" layoutId="activeIndicator" />}
                  </motion.div>
                </Link>;
        })}
          </div>
        </motion.div>}
    </AnimatePresence>;
};